import { Spin } from "antd";
import React, { useEffect, useState } from "react";
import TableStudents from "./TableStudents";
import { useLanguage } from "../../../../context/LanguageContext";
import { BaseUrlApi, ErrorMessage } from "../../../../lib/api";
import axios from "axios";
import { toast } from "sonner";
import { SubLessonData } from "../../../../lib/languages";

export default function TeacherStudents() {
  const { language } = useLanguage();
  const t = SubLessonData[language] || SubLessonData["en"];
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchStudents = async () => {
    try {
      const { data } = await axios.get(`${BaseUrlApi}/teacher/students`);
      setStudents(data.data);
    } catch (error) {
      const result = ErrorMessage(error);
      if (typeof result !== "object") toast("Error", { description: result });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchStudents();
  }, []);

  return (
    <div className="space-y-8" dir={language === "ar" ? "rtl" : "ltr"}>
      <h1 className="text-2xl font-bold">{t.studentsHeading}</h1>
      {!loading ? (
        <TableStudents data={students} />
      ) : (
        <div className="h-40 w-full flex items-center justify-center">
          <Spin size="large" />
        </div>
      )}
    </div>
  );
}
